import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import { MenuItem, type SelectChangeEvent, type SxProps, type Theme } from '@mui/material';
import { useMemo } from 'react';
import { OddsChangesType } from '../../../../@types';
import { ODD_CHANGES } from '../../../../constants';
import useLocalization from '../../../../hooks/useLocalization';
import { useUpdateUserData, useUserData } from '../../../../queries';
import NeobetSelectField from './NeobetSelectField';

const styles = {
  control: {
    minWidth: 120,
    flexShrink: 0,
  },
  menuItem: {
    typography: 'body3',
  },
} as const;

type NeobetOddsChangesSelectProps = {
  rootSx?: SxProps<Theme>;
  selectSx?: SxProps<Theme>;
};

const NeobetOddsChangesSelect = ({ rootSx, selectSx }: NeobetOddsChangesSelectProps) => {
  const { t, getLocalizedConfig } = useLocalization();
  const localizedOptions = useMemo(() => getLocalizedConfig(ODD_CHANGES), [getLocalizedConfig]);
  const { data: userSettings } = useUserData();
  const { mutate: updateUserSettings } = useUpdateUserData();

  const value = userSettings?.sportsbookConfig?.oddsChanges ?? 'none';
  const label = t('acceptChanges', 'Accept changes');

  const handleChange = (event: SelectChangeEvent) => {
    updateUserSettings({
      sportsbookConfig: {
        ...(userSettings?.sportsbookConfig ?? {}),
        oddsChanges: event.target.value as OddsChangesType,
      },
    });
  };

  return (
    <NeobetSelectField
      label={label}
      value={value}
      onChange={handleChange}
      inputProps={{
        id: 'neobet-odds-changes-select-input',
        'aria-label': label,
      }}
      IconComponent={KeyboardArrowDownRoundedIcon}
      testId='neobet-odds-changes-select'
      rootSx={rootSx}
      controlSx={styles.control}
      selectSx={selectSx}
      labelSx={{ letterSpacing: '0.22em' }}
    >
      {localizedOptions.map((option) => (
        <MenuItem key={option.key} value={option.key} sx={styles.menuItem}>
          {option.label}
        </MenuItem>
      ))}
    </NeobetSelectField>
  );
};

export default NeobetOddsChangesSelect;
